@if (!isLoading) {
  <div>
    @if (!hasError) {
      <div>
        @if (advertisementData?.adSize !== 'webFullImage') {
          <div
            class="advertisement-card"
            (click)="onAdClick()"
            (keydown.enter)="onAdClick()"
            [attr.tabindex]="0"
            >
            <div class="ad-content">
              <div class="ad-icon">
                @if (advertisementData?.secondaryImage) {
                  <img src="{{ advertisementData?.secondaryImage }}" alt="Ad Icon" />
                }
              </div>
              <div class="ad-text">
                <p class="ad-main-text">{{ advertisementData?.mainText }}</p>
                <p href="{{ advertisementData?.mainUrl }}" class="ad-url">
                  {{ advertisementData?.secondaryText }}
                </p>
              </div>
            </div>
            <div class="ad-image">
              <img [src]="advertisementData?.mainImage" alt="Ad" />
              @if (advertisementData?.adLabel) {
                <span class="ad-label">Ad</span>
              }
            </div>
          </div>
        } @else {
          <div
            class="advertisement-card-full"
            (click)="onAdClick()"
            style="display: grid"
            (keydown.enter)="onAdClick()"
            [attr.tabindex]="0"
            >
            <div class="ad-image-full">
              <img
                alt="Ad"
                style="width: 100%"
                [src]="!isDesktop() && advertisementData?.secondaryImage ? advertisementData?.secondaryImage : advertisementData?.mainImage" />
              @if (advertisementData?.adLabel) {
                <span class="ad-label-full">Ad</span>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}